import {Injectable} from '@angular/core';
import {Resolve} from '@angular/router';
import {Observable, of} from 'rxjs';
import {FacadeService} from '../../service/facade/facade.service';
import {catchError, map} from 'rxjs/operators';
import {Customer} from '../../../customer/shared/model/customer.model';

@Injectable()
export class CustomerResolver implements Resolve<Observable<Customer>> {
  constructor(private facadeService: FacadeService) {
  }

  resolve(): Observable<Customer> {
    return this.facadeService.getCustomer().pipe(
      map((data) => data),
      catchError(error => {
        return of({error: error});
      })
    );
  }
}
